import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

  constructor() {
    // Component has no initialization logic yet.
  }

}
